module.exports = __webpack_public_path__ + "img/linyun.b405e6e2.png";